var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cc64a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 4,
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28z",
    clipPath: "url(\"#cc64a\")"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M20 36l16-16"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 28 28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M20 36l16-16"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNo);
export default __webpack_public_path__ + "static/media/icon-no.962f85c55daaf65af390315fd7e5182b.svg";
export { ForwardRef as ReactComponent };